export enum ValueEnum {
  TOTAL_REVENUE = 'TOTAL_REVENUE',
  TOTAL_DEBT = 'TOTAL_DEBT',
  TOTAL_PAID = 'TOTAL_PAID',
  TOTAL_VOLUME = 'TOTAL_VOLUME',
  TOTAL_CASH = 'TOTAL_CASH',
}
